<div class="sku-panel" *ngIf="selectedSkus.length">
  <div class="sku-panal_container">
    <div class="sku-panel_title">{{ selectedSkus.length }} SKU's selected</div>
  </div>

  <div class="sku-panel_devider"></div>
    <app-sku-settings
      [skus]="selectedSkus"
    ></app-sku-settings>
</div>